import React from 'react';
import styled from 'styled-components';
import { colors } from 'helpers/ColorHelper';

const StyledButton = styled.button`
  background-color: inherit;
  color: ${props => (props.disabled ? colors.DISABLED_GRAY : colors.ULTRAMARINE_BLUE)};
  line-height: 36px;
  height: 36px;
  font-size: 14px;
  font-weight: bold;
  border: none;
  border-radius: 28px !important;
  padding: 1px 24px 0;
  text-align: center;
  cursor: ${props => (props.disabled ? 'not-allowed' : 'pointer')};
  &:hover {
    background-color: inherit;
  }
`;

const TextButton = ({ type = 'button', ...rest }) => <StyledButton type={type} {...rest} />;

export default TextButton;
